module.exports = __webpack_public_path__ + "static/media/billing1.7702bebf.jpg";